import {
  listUserManagementUsersQueryOptions,
  listUserManagementUsersSearchSchema,
} from "@project/application/user-management/users";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {UsersPage} from "./-page/users.page";
import {UsersPending} from "./-page/users.pending";

export const Route = createFileRoute("/_app/user-management/users/")({
  validateSearch: listUserManagementUsersSearchSchema,
  loaderDeps: ({search}) => search,
  loader: ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter")
      return queryClient.ensureQueryData(listUserManagementUsersQueryOptions(deps));
    void queryClient.prefetchQuery(listUserManagementUsersQueryOptions(deps));
    return;
  },
  component: UsersPage,
  errorComponent: AppErrorBoundary,
  pendingComponent: UsersPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
});
